//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import settings from '~/mixins/settings'
import {mapGetters} from "vuex";

export default {
  name: 'ScoreLine',
  mixins: [settings],
  props: {
    value: {
      type: Number,
      default: 4.9
    },
    position: {
      type: String,
      default: 'top'
    }
  },
  computed: {
    ...mapGetters({
      locale: 'lang/locale',
    }),
    showBadge () {
      return true
    },
    lang () {
      return this.locale === 'nl' ? 'nl' : 'en'
    },
    trLocale () {
      switch (this.locale) {
        case 'nl':
          return 'nl-NL'
        case 'gr':
          return 'el-GR'
        default:
          return 'en-GB'
      }
      return 'en-GB'
    }
  },
  mounted() {
    for (var e = document.getElementsByClassName("trustpilot-widget"), t = 0; t < e.length; ++t) {
      if (!window.Trustpilot) {
        continue
      }
      var i = e[t]
        , n = i.firstChild && i.firstChild.tagName;
      n && "IFRAME" !== n && window.Trustpilot.loadFromElement(i)
    }
  }
}
